import React from 'react'
import { TextField , FormHelperText } from '@mui/material'
const EditInline = ({formik , handleChange , name , placeholder , isOpen , setIsOpen}) => {
  return (
    <>
    
    <TextField
  
          placeholder={placeholder}
              type="text"
                sx={{
                  width: "360px",
                  borderRadius: "4px",
                 /* "& .MuiOutlinedInput-input":{
                    padding:"0 !important",
                 }, */
                  "& .MuiInputBase-root": { height: "37px" },
                  "& .MuiOutlinedInput": { height: "36px"},
                    "& .MuiOutlinedInput-notchedOutline": {border:"1px solid #DBDEE6"},
                }}
                
                value={formik.values.name}
                name={name}
                onChange={handleChange}
              />
              {formik.touched.name && Boolean(formik.errors.name) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.name}
            </FormHelperText>)}
    </>
  )
}

export default EditInline